module.exports = __webpack_public_path__ + "img/rule_bet.e9ed7b7b.png";